import React, { useEffect, useState } from "react";
import './Bitacoras.scss'
import TitleView from "../../../components/atoms/TitleView/TitleView";
import InputCalendario from "../../../components/atoms/InputCalendario/InputCalendario";
import InputLista from "../../../components/atoms/InputLista/InputLista";
import Button from "../../../components/atoms/Button/Button";
import ButtonGris from "../../../components/atoms/ButtonGris/ButtonGris";
import TablaBitacoras from "../../../components/molecules/TablaBitacoras/TablaBitacoras";
import { formateoBasico } from "../../../utilities/formateos";
import { transferisServiciosIntegracion } from "../TransferirServicios/transferisServiciosIntegracion";
import { getClients } from "../MonitoreoServicios/MonitoreoServiciosIntegracion";
import InputText from "../../../components/atoms/InputText/InputText";
import { jwtDecode } from "jwt-decode";
import { getBitacoras } from "./BitacorasIntegracion";
import GlovalCard from "../../../components/atoms/GlovalCard/GlovalCard";
import ScrollToTopButton from "../../../components/atoms/ScrollToTopButton";

const Bitacoras = () => {
    const [fechaActual, setfechaActual] = useState(new Date())
    const [fechaInicial, setFechaInicial] = useState(formateoBasico(fechaActual))
    const [fechaFinal, setFechaFinal] = useState(formateoBasico(fechaActual))
    const [proveedores, setProveedores] = useState([])
    const [proveedor, setProveedor] = useState()
    const [clientes, setClientes] = useState([])
    const [cliente, setCliente] = useState(null)
    const [rutas, setRutas] = useState([])
    const [ruta, setRuta] = useState(null)
    const [estructuras, setEstructuras] = useState([])
    const [estructura, setEstructura] = useState([])
    const [operadores, setOperadores] = useState([])
    const [operador, setOperador] = useState([])
    const [unidad, setUnidad] = useState([])
    const [tokenData, setTokenData] = useState([])
    const [bitacoras, setBitacoras] = useState([])
    const [bitacora, setBitacora] = useState("")

    const [actualizar, setActualizar] = useState(false)




    useEffect(() => {
        transferisServiciosIntegracion.getProveedores(setProveedores)
        getClients(setClientes)
        transferisServiciosIntegracion.getOperadores(setOperadores)
        setTokenData(jwtDecode(sessionStorage.getItem('token')))
        // inicializacion de campos
        setProveedor({ name: "SUMA TE LLEVA", code: 1 })
    }, [])
    useEffect(() => {
        if (cliente) {
            transferisServiciosIntegracion.getRutesByIdClient(cliente.code, setRutas)
        }
    }, [cliente])
    useEffect(() => {
        if (ruta) {
            transferisServiciosIntegracion.getEstructuraByRuta(ruta.code, setEstructuras)
        }
    }, [ruta])

    useEffect(() => {
    }, [bitacoras])
    

    const sumbit = () => {
        const data = {
            fecha_inicio: fechaInicial,
            fecha_fin: fechaFinal,
            proveedor: proveedor?.code ? proveedor.code : '',
            cliente: cliente?.code ? cliente.code : '',
            ruta: ruta?.code ? ruta.code : '',
            estructura: estructura?.code ? estructura.code : '',
            operador: operador?.code ? operador.code : '',
            unidad: unidad ? unidad : '',
            id_bitacora: bitacora ? bitacora : '',
        }
        getBitacoras(data, setBitacoras)
    }
    const limpiar = () => {
        setProveedor({ name: "SUMA TE LLEVA", code: 1 })
        setCliente(null)
        setRuta(null)
        setEstructura(null)
        setOperador(null)
        setUnidad(null)

    }

  
    useEffect(() => {
        if (actualizar !== false && actualizar === null  ) {
            sumbit()
        }
    }, [actualizar])

    return (
        <div className="Bitacoras">
            <ScrollToTopButton/>
            <TitleView title={"Bitacoras"}></TitleView>
            <b>
                <GlovalCard>
                    <div className="containerInputs">
                        <div className="containerFiltros">
                            <InputText title="Buscar por bitacora" type="number" value={bitacora} onChange={(e) => { setBitacora(e.target.value) }}></InputText>
                        </div>
                        <div className="containerFiltros">
                            <InputCalendario value={fechaInicial} onChange={(e) => { setFechaInicial(e.target.value) }} titulo={"Desde"} className={"tamañoInput"}></InputCalendario>
                            <InputCalendario value={fechaFinal} onChange={(e) => { setFechaFinal(e.target.value) }} titulo={"Hasta"} className={"tamañoInput"}></InputCalendario>
                            <InputLista placeholder={proveedor?.name} options={proveedores} value={proveedor} onChange={(e) => { setProveedor(e.value) }} titulo={"Proveedor"} className={"tamañoInput"}></InputLista>
                        </div>
                        <div className="containerFiltros">
                            <InputLista options={clientes} value={cliente} onChange={(e) => { setCliente(e.value) }} titulo={"Cliente"} className={"tamañoInput"}></InputLista>
                            <InputLista options={rutas} value={ruta} onChange={(e) => { setRuta(e.value) }} titulo={"Ruta"} className={"tamañoInput"}></InputLista>
                            <InputLista options={estructuras} value={estructura} onChange={(e) => { setEstructura(e.value) }} titulo={"Estructura"} className={"tamañoInput"}></InputLista>
                        </div>
                        <div className="containerFiltros">
                            <InputLista options={operadores} value={operador} onChange={(e) => { setOperador(e.value) }} titulo={"Operador"} className={"tamañoInput"}></InputLista>
                            <InputText value={unidad} onChange={(e) => { setUnidad(e.target.value) }} obligatorio type="number" title={"Unidad"} className={"tamañoInput"} > </InputText>
                            <div className="buttonContainer">
                                <Button onClick={() => { sumbit() }} className={"buttonG"} >Buscar</Button>
                                <ButtonGris onClick={() => { limpiar() }} className={"buttonL"}>Limpiar</ButtonGris>
                            </div>
                        </div>
                    </div>
                    <div className="tabla">
                        <TablaBitacoras 
                        data={bitacoras} setActualizar={setActualizar} actualizar={actualizar} reloadBitacoras={sumbit}></TablaBitacoras>
                    </div>
                </GlovalCard>
            </b>
        </div>
    )
}
export default Bitacoras